var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgControlAccordionOpen24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.272,0.923076886 C12.0029436,0.629873502 11.6342664,0.464584228 11.2493333,0.464584228 C10.8644004,0.464584228 10.4957231,0.629873502 10.2266667,0.923076886 L0.623999983,11.1415385 C0.174377727,11.6208865 0.174377727,12.397575 0.623999983,12.8769231 L10.2266667,23.0769231 C10.7972996,23.6397804 11.6835615,23.6216773 12.2335125,23.0359305 C12.7834636,22.4501838 12.8004604,21.5062362 12.272,20.8984615 L3.90866667,12 L12.2806667,3.07384613 C12.8300144,2.47482842 12.826155,1.51705026 12.272,0.923076886 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconActionAccordianDown24",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iconActionBackIos24",
    transform: "translate(11.500000, 12.000000) rotate(-90.000000) translate(-11.500000, -12.000000) translate(5.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "color",
    mask: "url(#mask-2)",
    fill: "#282828",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.933333, -2.769231)",
    id: "Rectangle-Copy-11"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 27.7333333,
    height: 29.5384615
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlAccordionOpen24);
export default __webpack_public_path__ + "static/media/controlAccordionOpen24.a99fe9de67bea933f45b280f8014aa52.svg";
export { ForwardRef as ReactComponent };